export default "__VITE_ASSET__CuGl8PFK__"